import { WizardSteps } from 'apps/applicationInstallation/constants/constants'
import { ActionItem } from 'shared/api/common/schemas/actionItem'
import { ApplicationBase, InstalledApplication } from 'shared/api/common/schemas/applications'
import {
  ActionDataMapping,
  ActionField,
  ActionFieldValue,
  ApplicationData,
} from 'shared/api/common/schemas/flow/actions'
import { SourceItem } from 'shared/api/common/schemas/sourceItem'
import { ConfigError } from 'shared/api/requests/applications/errors'
import {
  ApplicationAccount,
  ApplicationTrigger,
  AppSettings,
  ChangelogItem,
  DevApplicationWithAppId,
  GroupAppSettings,
  UsesDictonary,
} from 'shared/api/requests/applications/schemas'

export interface IApplicationsListItem {
  app_id: number
  versions: ApplicationBase[]
}

export interface IUpdateInstalledApplication {
  applicationId: number | null
  changelog: ChangelogState
  stage: UpdateStage
  updateFetching: boolean
}

export interface ChangelogState {
  changelogs: ChangelogItem[]
  fetching: boolean
}

export enum UpdateStage {
  Changelog = 'changelog',
  UsesList = 'usesList',
}

export interface IApplicationsState {
  list: {
    items: IApplicationsListItem[]
    fetching: boolean
  }
  current: ICurrentApplication
  publish: ISelectedApplicationState
  installation: IApplicationInstallationState
  reviewReport: IApplicationReviewReportState
  updateApplication: IUpdateInstalledApplication
  usesList: UsesListState
  settings: {
    update: { fetching: boolean; status: 'success' | 'error' | 'unknown' }
    data: {
      appKey: string
      deleteGroupId?: string
      fetching: boolean
      groupSettings: GroupAppSettings[]
      hasRequest: boolean
      settings: AppSettings[]
    }
  }
}

export interface ICurrentApplication {
  item: DevApplicationWithAppId | null
  fetching: boolean
  error: boolean | null
  updating?: boolean
  accounts?: []
  errors?: ConfigError[]
}

export interface UsesListState {
  fetching: boolean
  applicationId: number | null
  entities: UsesDictonary | null
}

export interface ISelectedApplicationState {
  applicationId: number | null
  fetching: boolean
}

export interface IApplicationReviewReportState extends ISelectedApplicationState {
  report: string
}

export interface IApplicationInstallationState {
  application: {
    application: InstalledApplication | null
    isFetching: boolean
    applicationIdOrHash: string
  }
  accounts: {
    items: ApplicationAccount[]
    selectedId: string | null
    isFetching: boolean
  }
  step: WizardSteps
}

export enum SelectedActionSource {
  ACTION_BUILDER = 'actionBuilder',
  ACTION_ITEM = 'actionItem',
}

// Flow builder
export interface IActionNodeApplicationState {
  selectedApplicationId: number | null
  selectedItemOid: string | null
  selectedAction: ActionItem | null
  selectedActionName: string | null
  selectedActionSource: SelectedActionSource | null
  actionFetching: boolean
  actionFields: IActionField[]
  actionMapping: IActionField[]
  actionSources: ActionSources
  triggers: ApplicationTrigger[]
}

export interface IActiveCampaignIntegration {
  isFetching: boolean
  isDisconnecting: boolean
  selectedList: number
  identityField: {
    value: string
    option: {
      value: string
      segment_type: string
    }
  }
  hasEmptyField: boolean
  lists: [
    {
      id: number
      name: string
      stringid: string
      isDefault: boolean
    },
  ]
}

export interface ActionSourceSupOptionType {
  label: string
  value: string
}

export interface ActionSourceOptionType {
  fetching: boolean
  reset?: boolean
  items: SourceItem[]
}

export type ActionSources = Record<string, ActionSourceOptionType>

// Action Node Interfaces
export interface IApplicationData extends ApplicationData {}

export interface IActionField extends ActionField {}

export interface IActionDataMapping extends ActionDataMapping {}

export interface IActionFieldValue extends ActionFieldValue {}
